<template>
	<v-snackbar auto-height multi-line top :timeout="timeout" v-model="show" :color="color">
		<span v-html="message"></span>
		<v-btn icon @click="show = false">
			<v-icon small>ti ti-close</v-icon>
		</v-btn>
	</v-snackbar>
</template>

<script>
export default {
    data: () => ({
        timeout: 0,
        show: false,
		color: 'info',
        message: ''
	}),
	computed: {
      snackbar () {
          return this.$store.state.general.snackbar
	  }
	},
	watch: {
        'snackbar' (val) {
            this.show = false
			if (val.message) {
				this.$nextTick(() => {
					this.color = val.color
					this.message = val.message
					this.timeout = val.timeout
					this.show = true
				})
			}
		}
	},
	methods: {
        success (message, timeout = 6000) {
            this.show = false
            this.$nextTick(() => {
                this.color = 'success'
                this.message = message
                this.timeout = timeout
                this.show = true
			})
		},
		error (message, error, timeout = 8000) {
            this.show = false
            this.timeout = timeout
			if (error.response) {
                if (error.response && error.response.data && error.response.data.errors) {
                    let errorList = error.response.data.errors
                    let items = []
                    errorList && Object.values(errorList).forEach((value, index) => {
                        items.push((index + 1) + `: ${value}`)
                    })
                    this.timeout = Object.keys(errorList).length * timeout
                    this.message = (`Hay ${Object.keys(errorList).length} ${Object.keys(errorList).length !== 1 ? 'errores' : 'error'}${message} <br> ${items.join('<br>')}`)
                } else if (error.response && error.response.data && (error.response.data.error || (error.response.data.message && typeof error.response.data.message === 'string'))) {
                    this.message = `Hay un error ${message} => ${error.response.data.error ? error.response.data.error : error.response.data.message} `
                } else {
                    this.message = `Hay un error ${message} => ${error.response.status}: ` + (error.response.data && error.response.data.message && error.response.data.message.Message ? error.response.data.message.Message : error.response.statusText)
                }
			} else {
                this.message = `Hay un error ${message}.`
			}
            this.$nextTick(() => {
                this.color = 'error'
                this.show = true
			})
		}
  	}
}
</script>